"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/UserPage/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






var _uuid = require('shared/services/uuid');


var _entities = require('shared/transforms/entities');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _org = require('shared/selectors/org');
var _user = require('shared/selectors/user');
var _peers = require('shared/selectors/peers');
var _useEntityPreload = require('shared/hooks/useEntityPreload'); var _useEntityPreload2 = _interopRequireDefault(_useEntityPreload);
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');






var _Header = require('web/components/RightSide/Header');
var _EntityNotFoundScreen = require('web/screens/EntityNotFoundScreen'); var _EntityNotFoundScreen2 = _interopRequireDefault(_EntityNotFoundScreen);
var _NameBadge = require('web/components/NameBadge'); var _NameBadge2 = _interopRequireDefault(_NameBadge);
var _Avatar = require('web/components/Avatar');
var _RecentChatsSection = require('web/screens/Directory/RecentChatsSection'); var _RecentChatsSection2 = _interopRequireDefault(_RecentChatsSection);
var _RightSide = require('web/components/RightSide');
var _DirectoryPage = require('../DirectoryPage');
var _InfoBtn = require('../components/InfoBtn'); var _InfoBtn2 = _interopRequireDefault(_InfoBtn);
var _EditCoworker = require('../Forms/EditCoworker'); var _EditCoworker2 = _interopRequireDefault(_EditCoworker);










const UserPage = ({
  orgKey,
  userKey,
  chatKey,
  onStartChat,
}) => {
  const user = _hooks.useAppSelector.call(void 0, state => _peers.selectUserByKey.call(void 0, state, userKey))
  const userEntity = _react.useMemo.call(void 0, 
    () => user &&
      _entities.mapUserToEntity.call(void 0, {}, _entities.makeSpecificOrgTitleUserDescription.call(void 0, orgKey))(user),
    [user, orgKey],
  )
  const orgName = _hooks.useAppSelector.call(void 0, state => _optionalChain([_org.selectOrgByKey.call(void 0, orgKey, state), 'optionalAccess', _ => _.Name]) || '')

  // GetUsers_V5 leaves out users the caller can't reach, such as someone from
  // an unrelated org known only from a chat. A page for a user the store
  // doesn't have then shows the error screen instead of rendering nothing.
  const [leftOutKey, setLeftOutKey] = _react.useState(null)
  const loadUser = _react.useCallback.call(void 0, 
    () => _actions2.default.getUsers(chatKey ? { UserKeys: [userKey], BKey: chatKey } : { UserKeys: [userKey] })
      .then(r => {
        if (!r.Users) throw new Error(`Failed to load user ${userKey}`)
        setLeftOutKey(Object.hasOwn(r.Users, userKey) ? null : userKey)
      }),
    [userKey, chatKey],
  )
  const hasLoadFailed = _useEntityPreload2.default.call(void 0, loadUser)

  // Org admins can edit a coworker's name and title; the server checks it too.
  const amIAdmin = _hooks.useAppSelector.call(void 0, state => _user.selectAmIAdminInOrg.call(void 0, state, orgKey))
  // The page stays mounted when the org or coworker changes, so an edit
  // belongs to the org and coworker it was opened for and ends on a switch,
  // without coming back when the switch is undone.
  const editKey = `${orgKey}:${userKey}`
  const [editingKey, setEditingKey] = _react.useState(null)
  const [shownKey, setShownKey] = _react.useState.call(void 0, editKey)
  if (shownKey !== editKey) {
    setShownKey(editKey)
    setEditingKey(null)
  }
  const isEditFormOpen = editingKey === editKey
  const onOpenEditForm = _react.useCallback.call(void 0, () => setEditingKey(editKey), [editKey])
  const onCloseEditForm = _react.useCallback.call(void 0, () => setEditingKey(null), [])
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const onSubmitEdit = _react.useCallback.call(void 0, 
    ({ firstName, lastName, suffix, title }) =>
      _actions2.default.updateOrgMember({
        UserKey: userKey,
        OrgKey: orgKey,
        FirstName: firstName,
        LastName: lastName,
        // Joi turns an empty optional field into undefined.
        PostNominals: _nullishCoalesce(suffix, () => ( '')),
        Title: _nullishCoalesce(title, () => ( '')),
      })
        .then(onCloseEditForm)
        .then(() => showSuccessBar('Coworker details updated'))
        .catch(() => showWarningBar('Failed to update coworker details')),
    [userKey, orgKey, onCloseEditForm, showSuccessBar, showWarningBar],
  )

  const loadRecentChats = _react.useCallback.call(void 0, 
    (_query, Offset, Limit) => orgKey !== _uuid.EMPTY_BLUID
      ? _actions2.default.getInboxForUser({ OrgKey: orgKey, UserKey: userKey, Offset, Limit })
      : Promise.resolve([]),
    [userKey, orgKey],
  )

  const onNewChat = _react.useCallback.call(void 0, 
    () => userEntity && onStartChat(userEntity),
    [onStartChat, userEntity],
  )

  if (hasLoadFailed || (!userEntity && leftOutKey === userKey)) return _react2.default.createElement(_EntityNotFoundScreen2.default, { desc: "Failed to load user"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}} )
  if (!userEntity) return null
  const isAdmin = _user.isUserAdminInOrg.call(void 0, userEntity.wrappedEntity, orgKey)
  const coworker = userEntity.wrappedEntity
  const editDefaults = {
    firstName: coworker.FirstName,
    lastName: coworker.LastName,
    suffix: 'PostNominals' in coworker ? _nullishCoalesce(coworker.PostNominals, () => ( '')) : '',
    title: _nullishCoalesce(_optionalChain([coworker, 'access', _2 => _2.Relationships, 'access', _3 => _3[orgKey], 'optionalAccess', _4 => _4.Title]), () => ( '')),
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, { key: userKey, __self: this, __source: {fileName: _jsxFileName, lineNumber: 129}}
      , _react2.default.createElement(_Header.RightSideHeader, { className: "chat-header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 130}}
        , _react2.default.createElement(_Header.HeaderMobileBackButton, { onClick: _actions2.default.gotoDirectory, __self: this, __source: {fileName: _jsxFileName, lineNumber: 131}} )
        , _react2.default.createElement(_Avatar.UserAvatar, { userKey: userKey, size: 40, __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}} )
        , _react2.default.createElement(_Header.RightSideHeaderHeading, {
          title: userEntity.name,
          titleBadge: isAdmin ? _react2.default.createElement(_NameBadge2.default, { label: "Admin", __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}} ) : null,
          subtitle: userEntity.description, __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}}
        )
        , _react2.default.createElement(_Header.HeaderItem, {
          iconName: "chat",
          'aria-label': "Start a chat"  ,
          className: "blmh-mobile-hide",
          onClick: onNewChat, __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
        )
      )
      , _react2.default.createElement(_RightSide.RightSideBody, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}
        , _react2.default.createElement(_DirectoryPage.DirectoryPage, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
          , _react2.default.createElement('div', { className: "directory-page--section-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}}, "General Information"

          )
          , _react2.default.createElement('div', { className: "directory-page--section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}}
            ,  isEditFormOpen
              ? (
                  _react2.default.createElement(_EditCoworker2.default, {
                    key: editKey,
                    defaultValues: editDefaults,
                    onSubmit: onSubmitEdit,
                    onCancel: onCloseEditForm,
                    controlsClassName: "directory-page--form-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 153}}
                  )
                )
              : (
                  _react2.default.createElement('div', { className: "directory-page--info-section", __self: this, __source: {fileName: _jsxFileName, lineNumber: 162}}
                    , _react2.default.createElement('div', { className: "directory-page--info-section--metadata", __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}
                      , _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 164}}
                        , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}}, "Name")
                        , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 166}},  userEntity.name )
                      )
                      , _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 168}}
                        , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 169}}, "Organization")
                        , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 170}},  orgName )
                      )
                      ,  userEntity.description && (
                        _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 173}}
                          , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 174}}, "Title")
                          , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}},  userEntity.description )
                        )
                      )
                      ,  userEntity.wrappedEntity.Email && (
                        _react2.default.createElement('div', { className: "directory-page--info-section--metadata-item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 179}}
                          , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}, "Email")
                          , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 181}}
                            ,  userEntity.wrappedEntity.Email 
                          )
                        )
                      )
                      ,  amIAdmin && (
                        _react2.default.createElement(_InfoBtn2.default, {
                          label: "Edit details" ,
                          onClick: onOpenEditForm,
                          iconSrc: "/assets/icons/icon-edit-purple.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}
                        )
                      )
                    )
                    , _react2.default.createElement(_Avatar.UserAvatar, {
                      userKey: userKey,
                      size: 72,
                      className: "directory-page--avatar", __self: this, __source: {fileName: _jsxFileName, lineNumber: 194}}
                    )
                  )
                )
          )
          , _react2.default.createElement(_RecentChatsSection2.default, {
            loadItemsList: loadRecentChats,
            onNewChat: onNewChat,
            entityName: userEntity.name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 202}}
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, UserPage)
